import React, { Fragment } from "react";
import * as _ from "lodash";
import "../../Invs/AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../../Invs/ShareFunctionsPrint";
import { Grid, Typography } from "@material-ui/core";
import BodyPump from "../EvryDay/A4/BodyPump";
import BodyDaily from "../EvryDay/A4/BodyDa";
import FooterA from "../../Safes/Jard/A4/FooterA";
import HeaderCashiar from "./Cashier/HeaderCashiar";
import BodyCashiar from "./Cashier/BodyCashiar";
import HeaderAShi from "./A4/HeaderAShi";
import BodyGroups from "./Cashier/BodyGroups";

function HeadersNew(props) {
    const { found ,infoData} = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderAShi Report={false} found={found} infoData={infoData}/>
        </div>
    );
}
function BodyPrint(props) {
    const { infoData } = props;
    return (
        <div style={stylePadding}>
            {infoData.kind == 1 || infoData.kind == 0?
                (
                    <BodyDaily
                        // data={infoData.data}
                        infoData={infoData}
                        isLast={true}
                    />
                ) : (
                    <BodyPump
                        data={infoData.data}
                        isLast={true}
                    />
                )}
        </div>
    );
}
function Footers(props) {
    const { found } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterA found={found} />
        </div>
    );
}

function ShiftsPrintCon(props) {
    const { info, dataAccounts, sta, onUnmountComplete } = props;
    return (
        <>{dataAccounts.isLarge ?
            <div className="invoicepreview">
                <div className="pageinv" >
                    <WaterMarkName found={info} />
                    <div className="contentview">
                        <HeadersNew found={info} infoData={dataAccounts} />
                        <BodyPrint infoData={dataAccounts} />
                    </div>
                    <Footers found={info} />
                </div>
            </div> :
            <Typography component="div" >
                <Grid item >
                    <Fragment>
                        <HeaderCashiar info={info} onUnmountComplete={onUnmountComplete} />
                        {dataAccounts?.isGroup? <BodyGroups infoData={dataAccounts}/>: <BodyCashiar infoData={dataAccounts}/>}
                       
                    </Fragment>
                </Grid>
            </Typography>
        }
        </>
    );
}
export default ShiftsPrintCon;
